import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type Filters } from '@pkg/types';

interface State {
    availableFilters?: Filters;
    isSortingDown: boolean;
    filteredResultsCount?: number;
    filterVisibility?: 'hidden' | 'visible';
    // showFilters: boolean;
}

interface Actions {
    clearFilters: () => void;
    setAvailableFilters: (availableFilters: State['availableFilters']) => void;
    setIsSortingDown: (value: boolean) => void;
    setFilteredResultsCount: (filteredResultsCount: State['filteredResultsCount']) => void;
    setFilterVisibility: (newFilter: State['filterVisibility']) => void;
    // setShowFilters: (value: boolean) => void;
}

type YatFiltersStoreState = Actions & State;

const initialState: State = {
    availableFilters: undefined,
    isSortingDown: true,
    filteredResultsCount: undefined,
    filterVisibility: undefined,
    // showFilters: false,
};

export const useYatFiltersStore = create<YatFiltersStoreState>()(
    devtools((set) => ({
        ...initialState,
        clearFilters: () => set({ filterVisibility: undefined }),
        setAvailableFilters: (availableFilters) => set({ availableFilters }),
        setIsSortingDown: (value) => set({ isSortingDown: value }),
        setFilteredResultsCount: (filteredResultsCount) => set({ filteredResultsCount }),
        setFilterVisibility: (newFilter) => set({ filterVisibility: newFilter }),
        // setShowFilters: (value) => set({ showFilters: value }),
    })),
);
